import * as React from 'react';
import { TextFormGroup, EmailFormGroup } from '../../uiComponents/input/FormGroups';
import { Row, Col, DropdownButton, DropdownButtonItemCallback } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { Laerer } from '../../models/Laerer';
import { RoundDeleteBtn } from '../../uiComponents/input/Buttons';

export interface LaererComponentProps {
    laerer: Laerer;
    tilmeldteLaerere: Laerer[];
    index: number;
    validationErrors: ValidationError[];
    onLaererChanged: (field: string, value: any, index: number) => void;
    onLaererRemoved: (index: number) => void;    
    editable: boolean;
}

class LaererComponent extends React.Component<LaererComponentProps, any> {
    constructor(props: LaererComponentProps) {
        super(props);

        this.onAnsvarligChanged = this.onAnsvarligChanged.bind(this);
        this.createAnsvarligDropDownItems = this.createAnsvarligDropDownItems.bind(this);
    }

    onAnsvarligChanged(e: any, index: number) {
        e.preventDefault();
        this.props.onLaererChanged('ansvarlig', true, index);
    }

    createAnsvarligDropDownItems() {
        let sortedLaerere = this.props.tilmeldteLaerere.sort((a: Laerer, b: Laerer) => {
            if (a.ansvarlig > b.ansvarlig) {
                return -1;
            }
            if (a.ansvarlig < b.ansvarlig) {
                return 1;
            }
            return 0;
        });

        let ansvarligDropDownItems = sortedLaerere.map((t, i) => {
            let ansvarlig = '';
            if (t.ansvarlig) {
               ansvarlig = ' (ansvarlig)'; 
            }
            return <DropdownButtonItemCallback key={i} text={t.navn + ansvarlig} onClick={(e: any) => this.onAnsvarligChanged(e, i)}/>;
        });

        return ansvarligDropDownItems;
    }

    render() {
        let navn = this.props.laerer.navn;
        if (this.props.laerer.navn === undefined) {
            navn = '';
        }
        let email = this.props.laerer.email;
        if (this.props.laerer.email === undefined) {
            email = '';
        }

        return (
            <div className='sub-section tilmelding-laerer'>
                <Row>
                    <Col md={4}>
                        <TextFormGroup
                            errorMessages={this.props.validationErrors}
                            label='Navn*'
                            name='navn'
                            value={navn}
                            disabled={!this.props.editable}
                            onChange={(fieldName: string, value: any) => this.props.onLaererChanged(fieldName, value, this.props.index)}
                        />
                    </Col>
                    <Col md={4}>
                        <EmailFormGroup
                            errorMessages={this.props.validationErrors}
                            label='E-mail*'
                            name='email'
                            value={email}
                            disabled={!this.props.editable}
                            onChange={(fieldName: string, value: any) => this.props.onLaererChanged(fieldName, value, this.props.index)}
                        />
                    </Col>
                    {this.props.laerer.ansvarlig &&
                        <div id='tilmeldte-laerere'>
                            <Col md={2}>
                                <DropdownButton title='Ansvarlig' buttonType='secondary' noCaret={false}>
                                    {this.createAnsvarligDropDownItems()}
                                </DropdownButton>

                            </Col>
                        </div>
                    }
                    <RoundDeleteBtn className='deletebtn' buttonOnClick={() => this.props.onLaererRemoved(this.props.index)}/>
                </Row>
            </div>
        );
    }
}

export default LaererComponent;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/LaererComponent.tsx